import React, { FC, useEffect } from 'react';
import FormContainer, { PreviousPage } from '../Shared/FormContainer/FormContainer';
import { FORM_SELECT_COMPONENT_TYPES } from './types';
import { FormSelectWrapper, SelectContainer } from './styled';
import { useForm } from 'react-hook-form';
import { RequireAtLeastOne } from '../../types';
interface FormSelectProps {
  formOptions: ReturnType<typeof useForm>;
  type?: keyof typeof FORM_SELECT_COMPONENT_TYPES;
  title?: string;
  previousPage?: PreviousPage;
  loading?: boolean;
  defaultValue?: string;
  componentItems?: { title: string; registerAs: string };
  options: { id: string; name: string }[];
  onSubmit: (data: Record<string, string>) => void;
}
const FormSelect: FC<RequireAtLeastOne<FormSelectProps, 'componentItems' | 'options'>> = ({ type, options, formOptions, onSubmit, title, loading, defaultValue, previousPage, componentItems }) => {
  const { title: defaultTitle, registerAs } = componentItems || FORM_SELECT_COMPONENT_TYPES[type!];
  const { register, handleSubmit, setValue } = formOptions;

  useEffect(() => {
    if (defaultValue && !loading) {
      setValue(registerAs, defaultValue);
    }
  }, [defaultValue, loading]);

  return (
    <FormSelectWrapper>
      <FormContainer title={title || defaultTitle} loadingData={loading} onSubmit={handleSubmit(onSubmit)} previousPage={previousPage}>
        <SelectContainer {...register(`${registerAs}`, { required: true })} disabled={loading} defaultValue={defaultValue}>
          {options?.length &&
            options.map(option => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
        </SelectContainer>
      </FormContainer>
    </FormSelectWrapper>
  );
};

export default FormSelect;
